import searchService from '@/services/search.service'

export default {
  async sendMessage({ commit, state }, payload) {
    try {
      // add user message
      commit("ADD_MESSAGE", {
        type: "user",
        text: payload.message,
      });

      commit("SET_LOADING", true);

      const body = {
        message: payload.message
      };
      if (state.conversationId) {
        body.conversation_id = state.conversationId
      }
      if (state?.lastSearchQuery) {
        body.last_search_query = state.lastSearchQuery
      }
      if (state?.searchRefinements && state.searchRefinements.length) {
        body.search_refinements = state.searchRefinements
      }
      if (state?.refinements && Object.keys(state.refinements).length) {
        body.refinements = state.refinements
      }
     
      const data  = await searchService.searchBot(body)
      // save conversation id first time
  
      if (!state.conversationId) {
        commit("SET_CONVERSATION_ID", data.conversation_id);
      }

      // save last search query
      if (data?.response.search_query) {
        commit(
          "SET_LAST_SEARCH_QUERY", 
          data?.response.search_query
        );
      }
      // save refinements returned from api
      if (data?.search_catalog?.refinements) {
        commit(
          "SET_REFINEMENTS",
          data.search_catalog?.refinements
        );
      }

      // save refinements returned from api
      if(data?.search_catalog?.searchRefinements) {
        commit(
          "SET_SERCH_REFINEMENTS",
          data.search_catalog?.searchRefinements
        )
      }

      if (data?.search_catalog?.products && !data.search_catalog?.products.length) {
        commit("ADD_MESSAGE", {
          type: "bot",
          text: 'No matching products were found based on your request. Please try again.',
          contentType: data.search_catalog?.products? "products" : null,
          products: data.search_catalog?.products?  _normalizeResponse(data.search_catalog) : null,
        });
      }
      if (data.question || data.search_catalog?.products?.length) {
         commit("ADD_MESSAGE", {
          type: "bot",
          text: data.question,
          contentType: data.search_catalog?.products? "products" : null,
          products: data.search_catalog?.products?  _normalizeResponse(data.search_catalog) : null,
        });
      }
     

      return data;
    } catch (error) {
      commit("ADD_MESSAGE", {
        type: "bot",
        messageType: "error",
        text: 'I encountered an error while thinking. Please try again soon!',
      });
      console.error(error);
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async clearChat({ commit }) {
    commit("CLEAR_MESSAGES");
    commit("SET_CONVERSATION_ID", null);
    commit("SET_LAST_SEARCH_QUERY", null);
    commit("SET_REFINEMENTS", null);
    commit("SET_SEARCH_REFINEMENTS", null);
    commit("SET_PRODUCTS", null);
  },
}

  

/**
   * 🔄 Normalize response
   */
  function _normalizeResponse(data) {
    return data.products.map((item) => ({
      id: item.id,
      asin: item.asin,
      title: item.title,
      productDescription:item.productDescription,
      productOverview: item.productOverview || {},
      price: item.price?.amount || item.price || item.offerPrice,
      seller: item.seller || item.sellerName,
      manufacturer: item.manufacturerName,
      countryOfOrigin: item.countryOfOrigin,
      imageUrl: _extractImageUrl(item),
      offers: item.includedDataTypes?.OFFERS,
      raw: item,
      unspscTitle: item.taxonomies.find(t => t.type === 'UNSPSC')?.title
    }))
  }

  /**
   * 📸 Extract image URL
   */

  function _extractImageUrl (item) {
    if (!item || typeof item !== 'object') return ''

    const includedImages =
      item.includedDataTypes?.IMAGES ||
      item.includedDataTypes?.images ||
      []

    if (Array.isArray(includedImages) && includedImages.length) {
      const img = includedImages[0]
      if (img && typeof img === 'object') {
        return (
          img.medium?.url ||
          img.large?.url ||
          
          img.original?.url ||
          img.small?.url ||
          img.thumbnail?.url ||
          img.url ||
          ''
        )
      }
    }

    return ''
  }
